var map = {
	"./uni-app.ar.json": 39441,
	"./uni-app.bn.json": 81210,
	"./uni-app.en.json": 31441,
	"./uni-app.hi.json": 31197,
	"./uni-app.in.json": 66133,
	"./uni-app.pt.json": 12158,
	"./uni-app.tr.json": 22556,
	"./uni-app.ur.json": 40237,
	"locale/uni-app.ar.json": 39441,
	"locale/uni-app.bn.json": 81210,
	"locale/uni-app.en.json": 31441,
	"locale/uni-app.hi.json": 31197,
	"locale/uni-app.in.json": 66133,
	"locale/uni-app.pt.json": 12158,
	"locale/uni-app.tr.json": 22556,
	"locale/uni-app.ur.json": 40237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99733;